// extracted by mini-css-extract-plugin
export var numpadContainer = "_i0-1";
export var phoneButton = "_i0-0";